import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=56989053&"
import script from "./HomeView.vue?vue&type=script&lang=js&"
export * from "./HomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports